import { SERVICE_CODES } from '@/lib/consts';

import { PayloadGroupMockup } from '../../../../../../components/Forms/constants';
import { WeaponsData } from '../../../../../../components/Forms/Steps/WeaponsData';
import { fieldNamesForServerFactory } from '../../../../../../helpers/fieldNamesForServerFactory';
import { ObjectListInputType } from '../../../../components/erz/ObjectList';
import { currentServiceCode } from '../TemporaryResidenceRelocation';

export enum WeaponsDataFieldName {
  weapons = 'weapons',
}

export interface WeaponsDataFormDataProps {
  [WeaponsDataFieldName.weapons]?: string[];
}

const payloadGroupName = 'weapon_data';

export const weaponsDataPayloadGroupMockup: PayloadGroupMockup<typeof payloadGroupName> = {
  [payloadGroupName]: {
    weapons: [],
  },
};

export const weaponsDataFieldNamesForServer = fieldNamesForServerFactory({
  groupName: payloadGroupName,
  fields: [
    {
      localFieldName: WeaponsDataFieldName.weapons,
      serverFieldName: 'weapons',
    },
  ],
});

type Props = {
  formData: WeaponsDataFormDataProps;
  handleInputChange: (name: string, value: unknown) => void;
};

const Step2: React.FC<Props> = ({ formData, handleInputChange }) => {
  return (
    <>
      {currentServiceCode === SERVICE_CODES.RESIDENCE_RELOCATION && (
        <WeaponsData
          weaponSelectType={ObjectListInputType.multipleReadonly}
          source={currentServiceCode}
          noWeaponsMessage={noWeaponsMessage}
        />
      )}

      {currentServiceCode === SERVICE_CODES.TEMPORARY_RESIDENCE_RELOCATION && (
        <WeaponsData
          weaponSelectType={ObjectListInputType.multiple}
          selectedWeapons={formData[WeaponsDataFieldName.weapons] ?? []}
          source={currentServiceCode}
          handleWeaponChange={(selectedWeapons): void =>
            handleInputChange(WeaponsDataFieldName.weapons, selectedWeapons)
          }
          noWeaponsMessage={noWeaponsMessage}
        />
      )}
    </>
  );
};

const noWeaponsMessage = (
  <div className="no-data-informer">
    <p className="no-data-informer__title">Зверніть увагу!</p>
    <p>У вас немає зброї для замовлення послуги</p>
  </div>
);

export default Step2;
